module.exports = __webpack_public_path__ + "img/43_85.c0059954.png";